import clsx from 'clsx';
import type { NeighborhoodPoint } from '@avisoma/shared';

const STATUS_DOT: Record<NeighborhoodPoint['status'], string> = {
  misplaced: '#ef4444',
  borderline: '#f59e0b',
  normal: '#d4d4d8',
};

export function CategoryNeighborhoodWorklist({
  points,
  hoveredId,
  onHover,
  onSelectCategory,
}: {
  points: NeighborhoodPoint[];
  hoveredId: number | null;
  onHover: (id: number | null) => void;
  onSelectCategory: (categoryId: number) => void;
}) {
  const candidates = points
    .filter((point) => point.status !== 'normal')
    .sort((a, b) => b.margin - a.margin);

  if (candidates.length === 0) {
    return <p className="text-xs text-gray-500 dark:text-zinc-400">No mislabel candidates.</p>;
  }

  return (
    <ul className="flex max-h-80 flex-col gap-1 overflow-y-auto">
      {candidates.map((point) => (
        <li key={point.id}>
          <button
            type="button"
            onMouseEnter={() => onHover(point.id)}
            onMouseLeave={() => onHover(null)}
            onClick={() => point.suggestedCategoryId !== null && onSelectCategory(point.suggestedCategoryId)}
            className={clsx(
              'flex w-full items-center gap-2 rounded-md border px-2 py-1.5 text-left text-xs',
              hoveredId === point.id
                ? 'border-gray-300 bg-gray-50 dark:border-zinc-600 dark:bg-zinc-700/50'
                : 'border-transparent',
            )}
          >
            <span
              className="inline-block size-2 shrink-0 rounded-full"
              style={{ backgroundColor: STATUS_DOT[point.status] }}
            />
            <span className="min-w-0 flex-1 truncate text-gray-900 dark:text-zinc-100">
              #{point.id}
              <span className="text-gray-400 dark:text-zinc-500"> → {point.suggestedCategoryName}</span>
            </span>
            <span className="shrink-0 tabular-nums text-gray-400 dark:text-zinc-500">{point.margin.toFixed(3)}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
